import React, { useEffect, useState } from "react";
import { useFormikContext } from "formik";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import Swal from "sweetalert2";
import { checkCheckboxRejectDetails } from "../../../../services/RegistrationService";
import { disabilityList } from "../../../../utils/commonFunction";
import { Title } from "../../../systemadministration/DataReactSelect";
import RenderPreviousValues from "./RenderPreviousValues";
import TextInput from "../../../../components/library/TextInput";
import SelectDropdown from "../../../../components/library/SelectDropdown";
import Checkbox from "../../../../components/library/Checkbox";
import Radio from "../../../../components/library/Radio";
import { tokens } from "../../../../public/tokens";

// Styled components
const FormField = styled.div`
  margin-bottom: 24px;
`;

const RequiredLabel = styled.label`
  font-size: ${tokens.typography.fontSize["lg-14px"]};
  font-family: ${tokens.typography.fontFamilies["albert-sans"]};
  font-weight: ${tokens.typography.fontWeights.medium};
  line-height: 20px;
  color: ${tokens.colors.ui.foreground};
  display: flex;
  align-items: center;
  gap: 4px;
  
  &::after {
    content: "*";
    color: ${tokens.colors.ui.destructive};
    margin-left: 2px;
  }
`;

/**
 * Null from API/NS will resolve to 'none' - 'No Disability Specified'.
 */
const defaultVisabilityData = {
  value: 'none',
  label: disabilityList()['none']
};

function StudentDetails(props) {
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const studentId = params.get("studentId");
  let dropdowns = useSelector((state) => state.registerDropdownValues)
  const [studentData, setStudentData] = useState();
  const [disablity, setDisablity] = useState([]);
  const [dropdownValues, setDropdownValues] = useState(useSelector((state) => state.registerDropdownValues));
  const history = useHistory()
  useEffect(() => {
    setStudentData(props.studentData);
    setDisablity([defaultVisabilityData, ...dropdownValues.disability]);
  }, [props]);
  
  const formik = useFormikContext();

  const getError = (field) => {
    return formik.errors[field] && formik.touched[field] ? formik.errors[field] : "";
  };
  const showError = (field) => Boolean(formik.errors[field] && formik.touched[field]);

  return (
    <div className="my-tickets-info-list Tickets-main-wrap">
    <div className="edit-icon new-card-header">
    <div className="card-header">Student Details</div>
    </div>
    <div className="row">
    <div className="col-md-6 col-lg-4">
    <FormField>
      <SelectDropdown
        id="Title"
        label={formik.values.course_type === "shortcourse" ? "Title" : "Title"}
        name="Title"
        options={Title.map((item) => ({
          value: item.value,
          label: item.label
        }))}
        value={formik.values.Title || ""}
        onChange={(event) => {
          formik.setFieldValue("Title", event.target.value);
        }}
        onBlur={formik.handleBlur}
        placeholder={formik.values.Title ? formik.values.Title : "Select Title  "}
        error={showError("Title")}
        errorText={getError("Title")}
        required={formik.values.course_type !== "shortcourse"}
        isClearable
        onClear={() => {
          formik.setFieldValue("Title", "");
        }}
      />
    </FormField>
    <RenderPreviousValues status={studentData?.re_reg_data?.status} currentValue={studentData?.re_reg_data?.title} previousValue={studentData?.RegStudentsPreviousDetails?.title} type="dropdown" typeSupportingProps={{filterArray : Title}} />
    </div>
    
    <div className="col-md-6 col-lg-4">
    <FormField>
      <TextInput
        id="FirstName"
        label="First Name"
        name="FirstName"
        value={formik.values.FirstName || ""}
        placeholder="Enter First Name"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={showError("FirstName")}
        errorText={getError("FirstName")}
        required
      />
    </FormField>
    <RenderPreviousValues status={studentData?.re_reg_data?.status} currentValue={studentData?.re_reg_data?.first_name} previousValue={studentData?.RegStudentsPreviousDetails?.first_name} />
    </div>
    <div className="col-md-6 col-lg-4">
    <FormField>
      <TextInput
        id="LastName"
        label="Last Name"
        name="LastName"
        value={formik.values.LastName || ""}
        placeholder="Enter Last Name"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={showError("LastName")}
        errorText={getError("LastName")}
        required
      />
    </FormField>
    <RenderPreviousValues status={studentData?.re_reg_data?.status} currentValue={studentData?.re_reg_data?.last_name} previousValue={studentData?.RegStudentsPreviousDetails?.last_name} />
    </div>
    <div className="col-md-6 col-lg-4">
    <FormField>
      <TextInput
        id="Initials"
        label="Initials"
        name="Initials"
        value={formik.values.Initials || ""}
        placeholder="Enter Initials"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={showError("Initials")}
        errorText={getError("Initials")}
      />
    </FormField>
    <RenderPreviousValues status={studentData?.re_reg_data?.status} currentValue={studentData?.re_reg_data?.initials} previousValue={studentData?.RegStudentsPreviousDetails?.initials} />
    </div>
    <div className="col-md-6 col-lg-4">
    <FormField>
      <TextInput
        id="SecondName"
        label="Second Name"
        name="SecondName"
        value={formik.values.SecondName || ""}
        placeholder="Enter Second Name"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={showError("SecondName")}
        errorText={getError("SecondName")}
      />
    </FormField>
    <RenderPreviousValues status={studentData?.re_reg_data?.status} currentValue={studentData?.re_reg_data?.second_name} previousValue={studentData?.RegStudentsPreviousDetails?.second_name} />
    </div>
    <div className="col-md-6 col-lg-4">
    <FormField>
      <TextInput
        id="ThirdName"
        label="Third Name"
        name="ThirdName"
        value={formik.values.ThirdName || ""}
        placeholder="Enter Third Name"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={showError("ThirdName")}
        errorText={getError("ThirdName")}
      />
    </FormField>
    <RenderPreviousValues status={studentData?.re_reg_data?.status} currentValue={studentData?.re_reg_data?.third_name} previousValue={studentData?.RegStudentsPreviousDetails?.third_name} />
    </div>
    <div className="col-md-6 col-lg-4">
    <FormField>
      <TextInput
        id="Email"
        label="Email"
        name="Email"
        value={formik.values.Email || ""}
        placeholder="Enter Email"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={showError("Email")}
        errorText={getError("Email")}
        required
      />
    </FormField>
    <RenderPreviousValues status={studentData?.re_reg_data?.status} currentValue={studentData?.re_reg_data?.email} previousValue={studentData?.RegStudentsPreviousDetails?.email} />
    </div>
    <div className="col-md-6 col-lg-4">
    <FormField>
      <TextInput
        id="RSAID"
        label={formik.values.course_type === "shortcourse" ? "Passport/RSA ID" : "Passport/RSA ID"}
        name="RSAID"
        value={formik.values.RSAID || ""}
        placeholder="Enter Passport/RSA ID"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={showError("RSAID")}
        errorText={getError("RSAID")}
        required={formik.values.course_type !== "shortcourse"}
      />
    </FormField>
    <RenderPreviousValues status={studentData?.re_reg_data?.status} currentValue={studentData?.re_reg_data?.id_number} previousValue={studentData?.RegStudentsPreviousDetails?.id_number} />
    </div>
    <div className="col-md-6 col-lg-4">
    <FormField>
      <TextInput
        id="Mobile"
        label="Mobile"
        name="Mobile"
        value={formik.values.Mobile || ""}
        placeholder="Enter Mobile"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={showError("Mobile")}
        errorText={getError("Mobile")}
        required
        iconRight={
          formik.values.Mobile ? <a href={`https://phone.myaie.ac?phoneNumber=${formik.values.Mobile}`} 
          style={{ display: 'inline' }}
          onMouseEnter={(e) => {
            e.target.style.color = '#1b6c15';
          }}
          onMouseLeave={(e) => {
            e.target.style.color = '#21cb15';
          }}
          >
          <i className="fal fa-phone ml-1" style={{ color: "#21cb15" }}></i></a>
          : null
        }
      />
    </FormField>
    <RenderPreviousValues status={studentData?.re_reg_data?.status} currentValue={studentData?.re_reg_data?.mobile} previousValue={studentData?.RegStudentsPreviousDetails?.mobile} />
    </div>
    <div className="col-md-6 col-lg-4">
    <FormField>
      <TextInput
        id="MaidenName"
        label="Maiden Name"
        name="MaidenName"
        value={formik.values.MaidenName || ""}
        placeholder="Enter Maiden Name"
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={showError("MaidenName")}
        errorText={getError("MaidenName")}
      />
    </FormField>
    <RenderPreviousValues status={studentData?.re_reg_data?.status} currentValue={studentData?.re_reg_data?.maiden_name} previousValue={studentData?.RegStudentsPreviousDetails?.maiden_name} />
    </div>
    <div className="col-md-6 col-lg-4">
    <FormField>
      <SelectDropdown
        id="Disablity"
        label={formik.values.course_type === "shortcourse" ? "Disability" : "Disability"}
        name="Disablity"
        options={disablity.map((item) => ({
          value: item.value,
          label: item.label
        }))}
        value={formik.values.DisablityId || ""}
        onChange={(event) => {
          const selected = disablity.find(
            (option) => option.value === event.target.value
          );
          if (selected) {
            formik.setFieldValue("Disablity", selected.label);
            formik.setFieldValue("DisablityId", selected.value);
          }
        }}
        onBlur={formik.handleBlur}
        placeholder={formik.values.Disablity ? formik.values.Disablity : "Select"}
        error={showError("Disablity")}
        errorText={getError("Disablity")}
        required={formik.values.course_type !== "shortcourse"}
        isClearable
        onClear={() => {
          formik.setFieldValue("Disablity", defaultVisabilityData.label);
          formik.setFieldValue("DisablityId", defaultVisabilityData.value);
        }}
      />
    </FormField>
    <RenderPreviousValues status={studentData?.re_reg_data?.status} currentValue={studentData?.re_reg_data?.disability} previousValue={studentData?.RegStudentsPreviousDetails?.disability} type="dropdown" typeSupportingProps={{filterArray : disablity}} />
    </div>
    <div className="col-md-6 col-lg-4">
    <FormField>
      <RequiredLabel htmlFor="AllowedExtraTime" title="Allowed Extra Time">
        Allowed Extra Time
      </RequiredLabel>
      <div className="form-icon-group" title="Allowed Extra Time" style={{ paddingLeft: 0 }}>
        <div className="custon_rd_new" style={{ paddingLeft: 0 }}>
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center', paddingLeft: 0, marginLeft: 0 }}>
            <div className="custom-control custom-radio custom-control-inline" title="Yes" style={{ paddingLeft: 0 }}>
              <Radio
                id="customRadioInline1"
                name="customRadioInline"
                value="Yes"
                size="lg"
                checked={formik.values.AllowedExtraTime === "Yes"}
                onChange={() => formik.setFieldValue("AllowedExtraTime", "Yes")}
                onBlur={formik.handleBlur}
                label="Yes"
                error={showError("AllowedExtraTime")}
              />
            </div>
            <div className="custom-control custom-radio custom-control-inline" title="No" style={{ paddingLeft: 0 }}>
              <Radio
                id="customRadioInline2"
                name="customRadioInline"
                value="No"
                size="lg"
                checked={formik.values.AllowedExtraTime === "No"}
                onChange={() => formik.setFieldValue("AllowedExtraTime", "No")}
                onBlur={formik.handleBlur}
                label="No"
                error={showError("AllowedExtraTime")}
              />
            </div>
          </div>
          <RenderPreviousValues status={studentData?.re_reg_data?.status} currentValue={studentData?.re_reg_data?.extra_time} previousValue={studentData?.RegStudentsPreviousDetails?.extra_time} type="allowedTime" typeSupportingProps={{filterArray : disablity}} />
        </div>
      </div>
    </FormField>
    </div>
    <div className="col-md-6 col-lg-4">
    <label>&nbsp;</label>
    <div className="form-group-blk mb-3" style={{ paddingTop: "11px" }}>
    <label></label>
    <div className="custom-check custom-control custom-checkbox custom-control-inline">
    <Checkbox
      id="RPL"
      name="select"
      size="md"
      checked={formik.values.RPL || false}
      onChange={e => {
        let data = {
          action: "recognition_learning",
          id: studentId,
          order: e.target.checked ? 1 : 0,
        }
        checkCheckboxRejectDetails(data).then(res => {
          Swal.fire("Updated", res.data.message, "success")
        }).catch(err => {
          console.error("error: ", err)
          Swal.fire("Not Updated", err.response.data.message, "error")
        })
        formik.setFieldValue("RPL", e.target.checked)
      }}
      label="RPL"
    />
    </div>
    </div>
    </div>
    </div>
    {/* <div className="form-group form-group-save-cancel">
    <button className="btn btn-save btn-success" type="submit" title="Update" disabled>
    {disabled ? <i className="fas fa-cog fa-spin"></i> : <i className="fal fa-save"></i>}
    Save
    </button>
    <button className="btn btn-save btn-success" type="submit" title="Update" disabled={disabled || !formik.dirty || isLoaded}>
    {disabled ? <i className="fas fa-cog fa-spin"></i> : <i className="fal fa-save"></i>}
    Post To Netsuite
    </button>
    <button className="btn btn-close btn-danger" type="button" title="Cancel" onClick={() => history.goBack()}>
    <i className="fal fa-times"></i>
    Cancel
    </button>
    
    {formik.touched.Title && formik.errors.Title ? <div className="invalid-feedback d-block">{formik.errors.Title}</div> : null}
    {formik.touched.Initials && formik.errors.Initials ? <div className="invalid-feedback d-block">{formik.errors.Initials}</div> : null}
    {formik.touched.FirstName && formik.errors.FirstName ? <div className="invalid-feedback d-block">{formik.errors.FirstName}</div> : null}
    {formik.touched.LastName && formik.errors.LastName ? <div className="invalid-feedback d-block">{formik.errors.LastName}</div> : null}
    {formik.touched.MaidenName && formik.errors.MaidenName ? <div className="invalid-feedback d-block">{formik.errors.MaidenName}</div> : null}
    {formik.touched.RSAID && formik.errors.RSAID ? <div className="invalid-feedback d-block">{formik.errors.RSAID}</div> : null}
    {formik.touched.Email && formik.errors.Email ? <div className="invalid-feedback d-block">{formik.errors.Email}</div> : null}
    {formik.touched.Mobile && formik.errors.Mobile ? <div className="invalid-feedback d-block">{formik.errors.Mobile}</div> : null}
    {formik.touched.Disablity && formik.errors.Disablity ? <div className="invalid-feedback d-block">{formik.errors.Disablity}</div> : null}
    {formik.touched.AllowedExtraTime && formik.errors.AllowedExtraTime ? <div className="invalid-feedback d-block">{formik.errors.AllowedExtraTime}</div> : null}
    </div> */}
    <div className="row"></div>
    <hr />
    </div>
  );
}

export default StudentDetails;
